export default __webpack_public_path__ + "static/media/filter.5b760a3a.svg";